export default __webpack_public_path__ + "static/media/mc_2Suit.cc37a53f.png";